const COMPANIES_WITHOUT_DELIVERY_PROMISE = ['1018']

export default COMPANIES_WITHOUT_DELIVERY_PROMISE
